import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GlobalTranslationService {

  constructor(private translate: TranslateService) {
    this.initializeTranslations();
  }

  private initializeTranslations(): void {
    // Set supported languages from environment
    this.translate.addLangs(environment.supportedLanguages);
    
    // Set default language from environment
    this.translate.setDefaultLang(environment.defaultLanguage);
    //console.log('Default language set to!!!:', environment.defaultLanguage);
    
    // Determine and set the active language
    const languageToUse = this.determineLanguage();
    this.translate.use(languageToUse);
    //console.log('Active language set to!!!:', languageToUse);
  }

  private determineLanguage(): string {
    const config = environment.translationConfig;
    const overrideLang = environment.selectedLanguage;
    if (overrideLang && this.isLanguageSupported(overrideLang)) {
      //console.log('Overriding language with environment:', overrideLang);
      return overrideLang;
    }
    
    // Check localStorage if enabled
    if (config.enableLocalStorage) {
      const savedLang = localStorage.getItem('selectedLanguage');
      if (savedLang && this.isLanguageSupported(savedLang)) {
        return savedLang;
      }
    }
    
    // Check browser language if enabled
    if (config.enableBrowserLanguageDetection) {
      const browserLang = this.translate.getBrowserLang();
      if (browserLang && this.isLanguageSupported(browserLang)) {
        return browserLang;
      }
    }
    
    // Fall back to environment default
    return environment.defaultLanguage;
  }

  private isLanguageSupported(lang: string): boolean {
    return environment.supportedLanguages.includes(lang);
  }

  public changeLanguage(language: string): void {
    if (this.isLanguageSupported(language)) {
      this.translate.use(language);
      
      if (environment.translationConfig.enableLocalStorage) {
        localStorage.setItem('selectedLanguage', language);
      }
    }
  }

  public getCurrentLanguage(): string {
    return this.translate.currentLang || environment.defaultLanguage;
  }

  public getSupportedLanguages(): string[] {
    return environment.supportedLanguages;
  }
}
